<template>
  <section class="admin-manual-login">
    <div class="card-container">
      <div class="card">
        <h1>Manual Email Login</h1>
        <p class="card-subtitle">
          Admin-only helper page for logging in with email & password even if the user usually signs in with Google.
        </p>

        <form @submit.prevent="manualLogin">
          <label for="admin-login-email">Email</label>
          <input
            id="admin-login-email"
            type="email"
            v-model.trim="email"
            placeholder="user@example.com"
            required
          >

          <label for="admin-login-password">Password</label>
          <input
            id="admin-login-password"
            type="password"
            v-model="password"
            placeholder="Temporary password to use"
            required
          >

          <button
            type="submit"
            :disabled="isLoading || !email || !password"
          >
            <span v-if="isLoading" class="spinner"></span>
            {{ isLoading ? 'Attempting login…' : 'Login with email & password' }}
          </button>
        </form>

        <p v-if="successMessage" class="status success">
          {{ successMessage }}
        </p>
        <p v-if="errorMessage" class="status error">
          {{ errorMessage }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex';

import { INTERNAL_HOME_PATH } from '@/common/appHome';
export default {
  name: 'AdminManualLogin',
  data() {
    return {
      email: '',
      password: '',
      isLoading: false,
      successMessage: '',
      errorMessage: '',
    };
  },
  methods: {
    ...mapActions(['authenticate']),
    async manualLogin() {
      this.successMessage = '';
      this.errorMessage = '';

      if (!this.email || !this.password) {
        this.errorMessage = 'Please enter both email and password.';
        return;
      }

      this.isLoading = true;
      try {
        this.$store.commit('setEmail', this.email.trim());
        this.$store.commit('setPassword', this.password);
        await this.authenticate();
        this.successMessage = 'Login request sent. Redirecting to home...';
        this.$router.push(INTERNAL_HOME_PATH);
      } catch (error) {
        console.error('Manual login failed', error);
        this.errorMessage = 'Login failed. Check the console/logs for more information.';
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.admin-manual-login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fb;
  padding: 40px 16px;
  font-family: 'Assistant', 'Open Sans', sans-serif;
}

.card-container {
  width: 100%;
  max-width: 480px;
}

.card {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 10px 35px rgba(15, 38, 91, 0.12);
  padding: 32px;
}

.card h1 {
  font-size: 24px;
  margin-bottom: 8px;
  color: #0f2d52;
  font-weight: 700;
}

.card-subtitle {
  color: #5c6c84;
  font-size: 14px;
  margin-bottom: 24px;
}

form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

label {
  font-weight: 600;
  font-size: 13px;
  color: #374151;
}

input {
  height: 48px;
  border-radius: 10px;
  border: 1px solid #dfe5ef;
  padding: 0 16px;
  font-size: 15px;
  transition: border-color 0.2s ease;
}

input:focus {
  outline: none;
  border-color: #4f8ef7;
  box-shadow: 0 0 0 3px rgba(79, 142, 247, 0.15);
}

button {
  margin-top: 8px;
  height: 48px;
  border-radius: 12px;
  border: none;
  background: linear-gradient(135deg, #2E2E3A 0%, #0f172a 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

button:not(:disabled):hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 25px rgba(47, 47, 58, 0.25);
}

.spinner {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.status {
  margin-top: 16px;
  font-size: 14px;
  padding: 12px;
  border-radius: 10px;
}

.status.success {
  background: #e8fff3;
  color: #0f5132;
  border: 1px solid #badbcc;
}

.status.error {
  background: #ffecec;
  color: #842029;
  border: 1px solid #f5c2c7;
}
</style>

